import { render, staticRenderFns } from "./DosingPlan.vue?vue&type=template&id=0ec8ade0&scoped=true"
import script from "./DosingPlan.vue?vue&type=script&lang=js"
export * from "./DosingPlan.vue?vue&type=script&lang=js"
import style0 from "./DosingPlan.vue?vue&type=style&index=0&id=0ec8ade0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8ade0",
  null
  
)

export default component.exports